import type {PropsWithChildren} from 'react';
import {type ComponentProps, type FC} from 'react';

import {cn} from '@/modules/foundation/shared/tailwind';

type CheckboxTileProps = Omit<ComponentProps<'input'>, 'type'> & {
	labelProps?: ComponentProps<'label'>;
};

export const CheckboxTile: FC<PropsWithChildren<CheckboxTileProps>> = ({
	className: inputClassName,
	labelProps: {className: labelClassName, ...restLabelProps} = {},
	children,
	...restInputProps
}) => {
	return (
		<label
			className={cn([
				'inline-flex items-center gap-2 rounded-sm border-2 border-neutral-600 bg-neutral-800/50 leading-0 font-semibold select-none',
				'h-12 px-3 text-base lg:h-14 lg:px-4 lg:text-lg',
				'has-checked:border-primary has-checked:outline-2 has-checked:-outline-offset-4 has-checked:outline-neutral-800',
				'has-focus:ring-primary has-focus:ring-2 has-focus:ring-offset-2 has-focus:ring-offset-neutral-800 has-focus-visible:ring-yellow-400',
				labelClassName,
			])}
			{...restLabelProps}
		>
			<input
				type="checkbox"
				className={cn([
					'rounded-sm border-2 border-neutral-600 bg-neutral-800',
					'size-5 lg:size-6',
					'checked:bg-primary checked:border-primary',
					'focus:ring-0 focus:ring-offset-0',
					inputClassName,
				])}
				{...restInputProps}
			/>
			<span>{children}</span>
		</label>
	);
};
